import {createContext, useContext} from 'react';
import {DetailsFilterContextValue} from './suppliers.types';

const Context = createContext<DetailsFilterContextValue>([[], () => {}]);

export const useShareFilter = () => useContext(Context);
export default Context;
